import { ApiRequestError } from './apiRequestError';

// Single fetch path for the whole client. Every failure — network, non-JSON,
// HTTP error — arrives as an ApiRequestError with a message that is safe to show
// a person, so no screen has to invent its own wording for "it broke".
export async function requestJson<T>(path: string, init?: RequestInit): Promise<T> {
  let response: Response;
  try {
    response = await fetch(path, {
      ...init,
      headers: { 'content-type': 'application/json', accept: 'application/json', ...(init?.headers ?? {}) }
    });
  } catch {
    throw new ApiRequestError(0, 'network_error', 'No connection. Check your network and try again.');
  }

  const raw = await response.text();
  let parsed: unknown = null;
  try {
    parsed = raw ? JSON.parse(raw) : null;
  } catch {
    parsed = null;
  }

  if (!response.ok) {
    const envelope = parsed as { error?: { code?: unknown; message?: unknown } } | null;
    const code = typeof envelope?.error?.code === 'string' ? envelope.error.code : 'request_failed';
    const message = typeof envelope?.error?.message === 'string'
      ? envelope.error.message
      : 'Something went wrong. Try again.';
    throw new ApiRequestError(response.status, code, message);
  }

  return parsed as T;
}
